import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { use_effect } from '@/hooks/_base/use_effect';
import { cn } from '@/utils/utils_client';
import { path_relative_to_absolute } from '@/utils/utils_files_client';
import { DTO__workspace } from '@shared/dto/+workspace/workspace_entity/DTO__workspace';
import { get_avatar_fallback_from_name } from '@shared/utils/utils_string';
import { ElementRef, FC, forwardRef, PropsWithChildren, useState } from 'react';

interface Props extends PropsWithChildren {
  workspace: DTO__workspace;
  className?: string;
}

export const WorkspaceAvatarReadOnly: FC<Props> = forwardRef<ElementRef<typeof Avatar>, Props>(({ workspace, className, children, ...props }, ref) => {
  const [fallback, setFallback] = useState(get_avatar_fallback());

  /*
   * EFFECTS
   */

  use_effect(() => {
    setFallback(get_avatar_fallback());
  }, [workspace]);

  /*
   * METHODS
   */

  function get_avatar_fallback() {
    let name = workspace.is_stub() ? '-' : workspace.name;

    return get_avatar_fallback_from_name(name);
  }

  return (
    <Avatar ref={ref} className={cn('rounded-md', className)} {...props}>
      {children}
      <AvatarImage src={path_relative_to_absolute(workspace.url_relative_avatar || '')} />
      <AvatarFallback className="!text-md !text-component-item-foreground">{fallback}</AvatarFallback>
    </Avatar>
  );
});
